import type { DefaultQueryError, PaymentMethod } from '@ahm/api-wrappers-core';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { apiRoutes } from '@/api/api-routes';
import { getCheckoutPaymentMethodFn } from '@/api/payment/get-checkout-payment-methods-fn';

export const useGetCheckoutPaymentMethod = (
  type: string,
  opts?: Omit<UseQueryOptions<PaymentMethod[], DefaultQueryError>, 'queryKey'>
) =>
  useQuery<PaymentMethod[], DefaultQueryError>({
    queryKey: [apiRoutes.payment.getCheckoutPaymentMethod, type],
    queryFn: () => getCheckoutPaymentMethodFn(type),
    ...opts,
  });
